import React, { createContext, useState, useEffect, useContext } from 'react';
import { SET_CONFIG_LANGUAGE } from 'services/gamecentreService';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [direction, setDirection] = useState('ltr');

  const inIframe = window.location !== window.parent.location;

  const setConfigLanguageHandler = (e) => {
    const { detail: configLanguage } = e
    setLanguage(configLanguage);
  }

  useEffect(() => {
    if (!inIframe) return;
    window.addEventListener(SET_CONFIG_LANGUAGE, setConfigLanguageHandler);
    return () => window.removeEventListener(SET_CONFIG_LANGUAGE, setConfigLanguageHandler);
  }, []);

  useEffect(() => {
    // Detect the `lang` parameter from the URL and set the language
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    if (lang) setLanguage(lang);
  }, []);

  useEffect(() => {
    // Update the document's `dir` attribute whenever the language changes
    setDirection(language === 'ar' ? 'rtl' : 'ltr');
  }, [language, direction]);

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === 'en' ? 'ar' : 'en'));
  };

  return (
    <LanguageContext.Provider value={{ 
        language, 
        direction, 
        toggleLanguage,
        rtlView: direction === 'rtl'
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);